import { Injectable } from '@angular/core';

import { IBooking } from 'libraries/service/resources/model/search/IBooking';
import { ITraveller } from 'libraries/service/resources/model/booking/ITraveller';
import { IAirPlace } from 'libraries/service/resources/model/booking/air/IAirPlace';
import { IAirTraveller, AirTravellerType } from 'libraries/service/resources/model/booking/air/IAirTraveller';
import { IBookingWithType } from './IBookingWithType';
import { SectorXType } from '../resources/model/search/air/IAirSector';
import { IGetBookingsAirResponse, ISectorAir } from '../resources/booking/interfaces/IGetBookings';

@Injectable()
export class AirBookingService {
    public isAirBooking(booking: IBookingWithType): boolean {
        return booking && booking.type && booking.type.indexOf('air') > -1;
    }

    public getMainTraveller(booking: IBooking): ITraveller {
        if (booking && booking.traveller) {
            return Object.keys(booking.traveller)
                .map((id: string) => booking.traveller[id])
                .filter((traveller: IAirTraveller) => traveller.type === AirTravellerType.Adult)[0];
        }
    }

    public getTrip(booking: IGetBookingsAirResponse): IAirPlace[][] | null {
        // booking canceled
        if (!booking.sector) {
            return null;
        }

        let currentTrip: IAirPlace[] = [];
        let previousTo: string = null;
        const result: IAirPlace[][] = [currentTrip];

        // The condition !sector.xType had been added for retro-compatibility reasons
        booking.sector
            .filter((sector: ISectorAir) => !sector.xType || sector.xType === SectorXType.air)
            .forEach((sector: ISectorAir) => {
                // Sometimes the data is not coherent, and the from or to
                // properties are not set
                // We need to handle these cases

                if (previousTo === null) {
                    addToTrip(sector.from, currentTrip);
                }

                if (sector.from.airport.code === previousTo || previousTo === null) {
                    addToTrip(sector.to, currentTrip);
                } else {
                    currentTrip = [];
                    addToTrip(sector.from, currentTrip);
                    addToTrip(sector.to, currentTrip);
                    result.push(currentTrip);
                }

                previousTo = sector.to && sector.to.airport && sector.to.airport.code;
            });

        return result;
    }
}

function addToTrip(location: IAirPlace, trip: IAirPlace[]): void {
    if (location) {
        trip.push(location);
    }
}